<div [formGroup]="formGroup" class="pt-2 c-form--d">
  <div class="c-form__section">
    <p500-ui-select-with-icon-field
      [data]="countries"
      [multiple]="multiple"
      i18n-label="@@common.country"
      label="Country"
      formControlName="country_code"
    ></p500-ui-select-with-icon-field>
  </div>
  <div class="c-form__section">
    <div class="p500-ui-form-field p500-ui-form-field--select">
      <label class="p500-ui-form-field__inner">
        <ng-select
          formControlName="region_code"
          [multiple]="true"
          [items]="options"
          [clearable]="false"
          bindValue="value"
          bindLabel="label"
          groupBy="group"
          placeholder="Select data"
          class="p500-ui-form-field__input"
          (add)="add($event)"
          (search)="search($event)"
        >
          <ng-template ng-optgroup-tmp let-item="item">
            <div *ngIf="item.group" class="p-1 font-weight-bold fs-1">
              {{ item.group }}
            </div>
          </ng-template>
        </ng-select>
        <span class="p500-ui-form-field__label-inner">
          <span class="p500-ui-form-field__label" i18n="@@common.region">Region</span>
        </span>
      </label>
      <div class="p500-ui-form-field__values">
        <ng-container *ngFor="let item of selectedRegions">
          <div class="p500-ui-form-field__value">
            <div class="p500-ui-form-field__value-title">{{ item.label | removePrefix }}</div>
            <div class="p500-ui-form-field__value-remove p500-ui-icon p500-ui-icon-close" (click)="remove(item)"></div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
